var map = {
	"./Bunny.jpeg": "5854",
	"./Claire.jpeg": "2c13",
	"./Maelenn.jpeg": "cf81",
	"./Michel.jpeg": "ee1d",
	"./Patrice.jpeg": "a9d8",
	"./Pauline.jpeg": "01ef",
	"./Sadia.jpeg": "2600",
	"./Vincent.jpeg": "4d83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c25a";